import { Text } from '@ui/atoms';
import Button from '@ui/atoms/design-system/Button';
import { buttonSizes } from '@ui/atoms/utils/enums';
import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@ui/atoms/utils/utils';

const LoginCTA = ({
    title,
    description,
    buttonText,
    onButtonClick,
    float = true,
    className = "",
}) => {
    return (
        <div
            className={cn(
                'flex flex-col items-center w-full gap-4 p-4 border shadow-xl md:gap-8 md:flex-row md:w-fit bg-login-cta rounded-xl border-secondary-200',
                className,
                {
                    'absolute -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2':
                        float,
                }
            )}
        >
            <div className="flex flex-col gap-1">
                <Text
                    content={title}
                    className="text-center h6-semibold text-primary-500 md:text-left"
                />
                <Text
                    content={description}
                    className="text-center p5-regular text-primary-500 md:whitespace-nowrap md:text-left"
                />
            </div>
            <Button
                buttonText={buttonText}
                buttonSize={buttonSizes.EXTRA_SMALL}
                onClick={onButtonClick}
                textClassName='!p5-medium'
            />
        </div>
    );
};

LoginCTA.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    buttonText: PropTypes.string.isRequired,
    onButtonClick: PropTypes.func.isRequired,
    float: PropTypes.bool,
    className:PropTypes.string
};

export default LoginCTA;
